import React from "react";
import "./terms.css";

import logoWhite from './logo_white.png';

const RefundPolicy = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top px-3">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img
              src={logoWhite}
              alt="KeyConnect Logo"
              style={{ height: "40px", marginLeft: "20px" }}
            />
          </a>
        </div>
      </nav>

      <section className="legal-page">
        <div className="wrap">
          <h1>Refund Policy</h1>

          <div className="legal-meta">
            <div>
              <strong>Effective Date:</strong> 8<sup>th</sup> July 2025
            </div>
            <div>
              <strong>Website:</strong>{" "}
              <a
                href="https://www.keyconnect.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.keyconnect.in
              </a>
            </div>
            <div>
              <strong>Platform:</strong> KeyConnect CRM
            </div>
          </div>

          <p>
            By subscribing to our platform, you acknowledge and agree to the
            terms set forth in this policy.
          </p>

          <section>
            <h2>1. General Refund Principle</h2>
            <p>
              All payments made to KeyConnect CRM are{" "}
              <strong>non-refundable</strong>, except in cases specifically
              mentioned below. Clients are advised to review the platform
              features, pricing, and service terms before making a purchase
              or subscription.
            </p>
          </section>

          <section>
            <h2>2. No Refunds for Monthly Subscriptions</h2>
            <ul>
              <li>
                Fees paid for <strong>monthly subscription plans</strong> are
                non-refundable once the billing cycle has commenced.
              </li>
              <li>
                No partial refunds will be provided for early cancellations,
                unused days, or reduced usage within a billing month.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Refunds on Annual Plans</h2>
            <ul>
              <li>
                Clients subscribing to <strong>annual plans</strong> may
                request a refund only if:
                <ul>
                  <li>
                    Cancellation is made within the{" "}
                    <strong>first 30 calendar days</strong> of the
                    subscription period.
                  </li>
                  <li>
                    The Client has{" "}
                    <strong>not heavily used or integrated</strong> the
                    system (e.g., setup complete, bulk imports done, or
                    significant data entered).
                  </li>
                </ul>
              </li>
              <li>
                If approved, refunds will be <strong>pro-rated</strong> based
                on the unused quarters of the subscription year, less
                applicable setup or service charges.
              </li>
            </ul>
          </section>

          <section>
            <h2>4. One-Time Setup &amp; Customization Fees</h2>
            <ul>
              <li>
                Fees paid for <strong>one-time services</strong>, such as
                onboarding, implementation, customization, or training, are{" "}
                <strong>non-refundable</strong> under all circumstances.
              </li>
            </ul>
          </section>

          <section>
            <h2>5. Third-Party Service Costs</h2>
            <ul>
              <li>
                Refunds will <strong>not</strong> be provided for any
                third-party integrations or prepaid credits activated
                through KeyConnect CRM, including but not limited to:
                <ul>
                  <li>SMS credits</li>
                  <li>WhatsApp API charges</li>
                  <li>IVR setup and usage</li>
                  <li>Meta Ads or lead generation tools</li>
                </ul>
              </li>
            </ul>
            <p>
              Once purchased or provisioned, these services are considered
              consumed and non-refundable.
            </p>
          </section>

          <section>
            <h2>6. Service Downtime or Technical Issues</h2>
            <ul>
              <li>
                We strive to maintain 99.5% uptime. In rare cases of
                prolonged downtime (beyond 72 continuous hours), a{" "}
                <strong>credit</strong> may be issued at our discretion
                toward the next billing cycle.
              </li>
              <li>
                Downtime due to third-party services, user-side issues, or
                external hosting failures are{" "}
                <strong>not eligible</strong> for refund or compensation.
              </li>
            </ul>
          </section>

          <section>
            <h2>7. Refund Request Process</h2>
            <p>To request a refund under the conditions specified:</p>
            <ul>
              <li>
                Email a formal request to{" "}
                <a href="mailto:support@keyconnect.in">support@keyconnect.in</a>{" "}
                with the following details:
                <ul>
                  <li>Registered account email</li>
                  <li>Payment receipt or invoice reference</li>
                  <li>Reason for refund request</li>
                </ul>
              </li>
            </ul>
            <p>
              Refund requests will be reviewed within{" "}
              <strong>7 business days</strong>, and if approved, the refund
              will be processed within <strong>15 business days</strong> via
              the original payment method.
            </p>
          </section>

          <section>
            <h2>8. Changes to This Policy</h2>
            <p>
              KeyConnect CRM reserves the right to update or amend this
              Refund Policy at any time. All changes will be reflected with
              a revised <strong>"Effective Date"</strong> at the top of the
              policy. Continued use of the platform constitutes acceptance
              of any changes.
            </p>
          </section>

          <section>
            <h2>9. Contact for Refund Queries</h2>
            <p>
              <strong>KeyConnect CRM – Billing &amp; Accounts</strong>
              <br />
              Email:{" "}
              <a href="mailto:support@keyconnect.in">support@keyconnect.in</a>
              <br />
              Website:{" "}
              <a
                href="https://www.keyconnect.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.keyconnect.in
              </a>
            </p>
          </section>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-dark text-light text-center py-4">
        <small>
          &copy; {new Date().getFullYear()} KeyConnect CRM. All rights reserved.
        </small>
      </footer>
    </div>
  );
};

export default RefundPolicy;